import { RootState, useAppSelector } from '..';

export const selectMachineList = (state: RootState) => state.machineList;
export const useMachineList = () => useAppSelector(selectMachineList);
